/* ============================================================
   ring-case-upsell.js
   Lógica do upsell de Estojo Porta Anel no cart drawer.
   ============================================================ */

(function () {
  'use strict';

  /* ---------- CONFIGURAÇÃO ---------- */
  const CONFIG = {
    caseVariantId: '57947933802799',
    qualifyingTag: 'estojo',
  };

  /* ---------- CACHE DE TAGS ---------- */
  const tagCache = {};

  async function productHasTag(handle, tag) {
    if (tagCache[handle] !== undefined) return tagCache[handle];
    try {
      const res = await fetch('/products/' + handle + '.js');
      const product = await res.json();
      const hasTag = product.tags && product.tags.some(
        t => t.toLowerCase() === tag.toLowerCase()
      );
      tagCache[handle] = hasTag;
      return hasTag;
    } catch (e) {
      console.error('[RingCaseUpsell] Erro ao buscar tags:', handle, e);
      return false;
    }
  }

  /* ---------- HELPER: busca elementos frescos ---------- */
  function getEl(id) {
    return document.getElementById(id);
  }

  /* ============================================================
     LÓGICA PRINCIPAL
     ============================================================ */
  const RingCaseUpsell = {
    _checking: false,
    _adding: false,

    init() {
      this.bindCheckbox();
      this.checkCart();
      this.interceptFetch();
      this.observeCartChanges();
    },

    /* --- Bind checkbox (sempre busca elemento fresco) --- */
    bindCheckbox() {
      const checkbox = getEl('ring-case-checkbox');
      if (!checkbox) return;

      // Remove listener antigo clonando o elemento
      const newCheckbox = checkbox.cloneNode(true);
      checkbox.parentNode.replaceChild(newCheckbox, checkbox);

      newCheckbox.addEventListener('change', () => this.onCheckboxChange());
    },

    /* --- Checagem do Carrinho --- */
    async checkCart() {
      if (this._checking) return;
      this._checking = true;

      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        const analysis = await this.analyzeCart(cart);
        const hasCaseInCart = this.hasCaseInCart(cart);
        const shouldShow = analysis.hasQualifyingProduct;

        // Busca elementos frescos a cada check
        const wrapper = getEl('ring-case-upsell');
        const checkbox = getEl('ring-case-checkbox');

        if (wrapper) {
          wrapper.style.display = shouldShow ? 'block' : 'none';
        }

        if (shouldShow && checkbox) {
          checkbox.checked = hasCaseInCart;
        }

        // Se não deve mostrar mas tem estojo, remove o estojo
        if (!shouldShow && hasCaseInCart) {
          await this.removeCaseFromCart(cart);
        }

      } catch (e) {
        console.error('[RingCaseUpsell] Erro ao verificar carrinho:', e);
      } finally {
        this._checking = false;
      }
    },

    /**
     * Analisa todos os itens do carrinho.
     */
    async analyzeCart(cart) {
      let hasQualifyingProduct = false;

      for (const item of cart.items) {
        if (String(item.variant_id) === String(CONFIG.caseVariantId)) continue;
        if (item.properties && item.properties._estojo === 'true') continue;

        if (item.handle) {
          const hasTag = await productHasTag(item.handle, CONFIG.qualifyingTag);
          if (hasTag) {
            hasQualifyingProduct = true;
            break;
          }
        }
      }

      return { hasQualifyingProduct };
    },

    /* --- Estojo no Carrinho --- */
    hasCaseInCart(cart) {
      return cart.items.some(
        item => String(item.variant_id) === String(CONFIG.caseVariantId)
          && item.properties
          && item.properties._estojo === 'true'
      );
    },

    getCaseKeyInCart(cart) {
      const found = cart.items.find(
        item => String(item.variant_id) === String(CONFIG.caseVariantId)
          && item.properties
          && item.properties._estojo === 'true'
      );
      return found ? String(found.key) : null;
    },

    /* --- Adicionar / Remover --- */
    async addCaseToCart() {
      if (this._adding) return;
      this._adding = true;

      const wrapper = getEl('ring-case-upsell');
      if (wrapper) wrapper.classList.add('ring-case-upsell__loading');

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: CONFIG.caseVariantId,
              quantity: 1,
              properties: {
                '_estojo': 'true'
              }
            }]
          })
        });

        // Atualiza o conteúdo do cart drawer sem fechar
        this.refreshCartContent();

      } catch (e) {
        console.error('[RingCaseUpsell] Erro ao adicionar estojo:', e);
        const checkbox = getEl('ring-case-checkbox');
        if (checkbox) checkbox.checked = false;
      } finally {
        this._adding = false;
        if (wrapper) wrapper.classList.remove('ring-case-upsell__loading');
      }
    },

    async removeCaseFromCart(cart) {
      if (!cart) {
        const res = await fetch('/cart.js');
        cart = await res.json();
      }

      const caseKey = this.getCaseKeyInCart(cart);
      if (!caseKey) return;

      const wrapper = getEl('ring-case-upsell');
      if (wrapper) wrapper.classList.add('ring-case-upsell__loading');

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: caseKey, quantity: 0 })
        });

        this.refreshCartContent();

      } catch (e) {
        console.error('[RingCaseUpsell] Erro ao remover estojo:', e);
      } finally {
        if (wrapper) wrapper.classList.remove('ring-case-upsell__loading');
      }
    },

    /* --- Atualiza o carrinho após adicionar/remover --- */
    refreshCartContent() {
      // Se está na página /cart, recarrega para atualizar totais
      if (window.location.pathname.includes('/cart')) {
        window.location.reload();
        return;
      }

      // Se está no cart drawer, atualiza via AJAX
      fetch('/?sections=mini-cart')
        .then(res => res.json())
        .then(sections => {
          const html = sections['mini-cart'];
          if (!html) return;

          const temp = document.createElement('div');
          temp.innerHTML = html;

          const miniCart = document.getElementById('mini-cart');
          const newMiniCart = temp.querySelector('#mini-cart');

          if (miniCart && newMiniCart) {
            miniCart.innerHTML = newMiniCart.innerHTML;
            this.bindCheckbox();
            setTimeout(() => this.checkCart(), 300);
          }
        })
        .catch(e => {
          console.error('[RingCaseUpsell] Erro ao atualizar drawer:', e);
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
        });
    },

    /* --- Evento do Checkbox --- */
    async onCheckboxChange() {
      const checkbox = getEl('ring-case-checkbox');
      if (!checkbox) return;

      if (checkbox.checked) {
        await this.addCaseToCart();
      } else {
        await this.removeCaseFromCart();
      }
    },

    /* --- Intercepta fetch para detectar mudanças no carrinho --- */
    interceptFetch() {
      const self = this;
      const originalFetch = window.fetch;

      window.fetch = function (...args) {
        const promise = originalFetch.apply(this, args);
        const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

        // Quando qualquer chamada ao /cart/ acontece (add, change, update),
        // re-checa o carrinho após um delay
        if (url.includes('/cart/') && !url.includes('/cart.js')) {
          promise.then(() => {
            setTimeout(() => {
              self.bindCheckbox();
              self.checkCart();
            }, 600);
          }).catch(() => {});
        }

        return promise;
      };
    },

    /* --- MutationObserver para re-renders do cart drawer --- */
    observeCartChanges() {
      const self = this;
      let debounceTimer = null;

      const observer = new MutationObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          self.bindCheckbox();
          self.checkCart();
        }, 300);
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  };

  /* ============================================================
     INICIALIZAÇÃO
     ============================================================ */
  window.RingCaseUpsell = RingCaseUpsell;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => RingCaseUpsell.init());
  } else {
    RingCaseUpsell.init();
  }

  // Retry de segurança após 1.5s
  setTimeout(() => RingCaseUpsell.init(), 1500);

})();